import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../catalyst/button';
import InputWithError from '../../catalyst/custom/inputWithError';
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../../catalyst/dialog';
import { ErrorMessage, Field } from '../../catalyst/fieldset';
import { Strong } from '../../catalyst/text';
import Spinning from '../../components/spinning';
import config from '../../config';
import { getCaTypetoName } from '../../utils';

export default function CreateSyncModel({transferHistory, createSyncModelOpen, setCreateSyncModelOpen}) {

    const navigate = useNavigate();

    const [submitting, setSubmitting] = useState(false)

    const [errors, setErrors] = useState({})
    const [errResponse, setErrResponse] = useState("");

    const [name, setName] = useState(transferHistory.playlistName + ": [" + getCaTypetoName(transferHistory.sourceAccountType, transferHistory.isSourceYTM) + " to " + getCaTypetoName(transferHistory.destinationAccountType, transferHistory.isDestYTM) +"]")

    function createSync() {


        setErrors({})

        if(name.length < 3) {
            setErrors({name: "Please add atleast 3 letters"})
            return
        }

        setSubmitting(true)
        setErrResponse("")

        fetch(config.apiUrl + "/sync/create", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
            },
            body: JSON.stringify({syncInterval:"DAILY", transferId: transferHistory.id, name:name}),
        }).then(response => {
            if (!response.ok) {
                throw new Error('Failed to create sync. Please try again or contact us');
            }
            return response.json();
        })
            .then(jsonData => {
                setCreateSyncModelOpen(false)
                setSubmitting(false)
                setErrResponse("")
                navigate('/dashboard/sync/' + jsonData.id)
            })
            .catch(error => {
                setSubmitting(false)
                setErrResponse(error.message)
            });

    }

    console.log("Rendering")

  return (
    <>
      <Dialog open={createSyncModelOpen} onClose={setCreateSyncModelOpen}>
        <DialogTitle>Create Sync</DialogTitle>
        <DialogDescription>
            Create daily sync for playlist {<Strong>{transferHistory.playlistName}</Strong>} 
        </DialogDescription>
        <DialogDescription>
            From {<Strong>{getCaTypetoName(transferHistory.sourceAccountType, transferHistory.isSourceYTM)}</Strong>} to {<Strong>{getCaTypetoName(transferHistory.destinationAccountType, transferHistory.isDestYTM)}</Strong>}
        </DialogDescription>
        <DialogBody>
          <InputWithError value={name} error={errors.name} type={"name"} name={"name"} label={"Name"} required={true} onChange={(e) => setName(e.target.value)}/>
          {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setCreateSyncModelOpen(false)}>
            Cancel
          </Button>

          <Button onClick={() => {createSync()}} className="w-full" disabled={submitting}>
                        {submitting ? <Spinning /> : "Create Sync"}
            </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
